import bookmarkFill from './module/bookmarkFill';
import addClassName from './module/addClassName';
import {tearTheBagIconAdd} from './module/tearTheBagIconAdd';

//シングルページ用
(function() {
  window.addEventListener('DOMContentLoaded', function(e) {
		bookmarkFill();
		const anchors = document.querySelectorAll('.c-post__body a');
		console.log(anchors);
		addClassName(anchors);
		tearTheBagIconAdd();
	});
})();
